var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React from "react";

var LegacyBoundary = function (_super) {
  __extends(LegacyBoundary, _super);

  function LegacyBoundary() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.state = {
      error: undefined
    };
    return _this;
  }

  LegacyBoundary.prototype.unstable_handleError = function (error) {
    var _a = this.props,
        appsignal = _a.instance,
        action = _a.action;
    var name = error.name,
        message = error.message,
        stack = error.stack;
    var span = appsignal.createSpan();
    span.setAction(action !== "" ? action : undefined).setError({
      name: name,
      message: message,
      stack: stack
    }).setTags({
      framework: "Legacy React"
    });
    appsignal.send(span);
    this.setState({
      error: error
    });
  };

  LegacyBoundary.prototype.render = function () {
    return React.createElement("div", null, !this.state.error ? this.props.children : this.props.fallback ? this.props.fallback(this.state.error) : null);
  };

  LegacyBoundary.defaultProps = {
    action: ""
  };
  return LegacyBoundary;
}(React.Component);

export { LegacyBoundary };